<template>
  <div class="password-strength-indicator" v-if="password && showRequirements">
    <p class="requirements-intro">Bitte verwenden Sie ein Passwort, das mindestens Folgendes enthält:</p>
    <ul class="requirements">
      <li :class="{ met: hasMinLength }">12 Zeichen</li>
      <li :class="{ met: hasUpper }">1 Großbuchstabe</li>
      <li :class="{ met: hasLower }">1 Kleinbuchstabe</li>
      <li :class="{ met: hasNumber }">1 Zahl</li>
      <li :class="{ met: hasSpecial }">1 Sonderzeichen</li>
    </ul>
  </div>
</template>

<script>
import { passwordStrength } from '@/functions/validators'

export default {
  name: 'CPasswordStrengthIndicator',
  
  props: {
    password: {
      type: String,
      default: ''
    },
    showRequirements: {
      type: Boolean,
      default: false
    }
  },
  
  computed: {
    strengthLevel () {
      return passwordStrength(this.password)
    },
    
    hasMinLength () {
      return this.password.length >= 12
    },
    
    hasUpper () {
      return /[A-Z]/.test(this.password)
    },
    
    hasLower () {
      return /[a-z]/.test(this.password)
    },
    
    hasNumber () {
      return /\d/.test(this.password)
    },
    
    hasSpecial () {
      return /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(this.password)
    }
  }
}
</script>

<style scoped>
.password-strength-indicator {
  width: 100%;
  margin-bottom: 8px;
  padding: 12px 14px;
  background-color: #f8f9fa;
  border-radius: 4px;
  box-sizing: border-box;
  grid-column: 1 / -1;
  font-size: 14px;
}

.requirements-intro {
  margin: 0 0 8px 0;
  font-size: 13px;
  color: #6c757d;
  line-height: 1.4;
}

.requirements {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 16px;
  font-size: 15px;
  font-weight: bold;
}

.requirements li {
  color: #6c757d;
  position: relative;
  padding-left: 18px;
  transition: color 0.2s ease;
}

.requirements li::before {
  content: "✓";
  position: absolute;
  left: 0;
}

.requirements li.met {
  color: #27ae60;
}

.requirements li.met::before {
  color: #27ae60;
}
</style>
